import {ObjectComboMapping} from "../../../model/object-combo-mapping";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectComboMappingSelectorProps = {};

export const objectComboMappingSelector = () => createSelector(
  [getUseQueryResultData<ObjectComboMapping>],
  (data) => {
    return data ? transformObjectComboMapping(data) : undefined;
  }
);

export const objectComboMappingsSelector = () => createSelector(
  [getUseQueryResultData<ObjectComboMapping[]>],
  (data) => {
    return selectObjectComboMappingsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectComboMapping = (value: ObjectComboMapping): ObjectComboMapping => {
  return {...value}
}

export const selectObjectComboMappings = (values?: ObjectComboMapping[], selector?: ObjectComboMappingSelectorProps): ObjectComboMapping[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectComboMappingsAndTransform = (values?: ObjectComboMapping[], selector?: ObjectComboMappingSelectorProps): ObjectComboMapping[] => {
  const selected = selectObjectComboMappings(values, selector);
  return selected.map(transformObjectComboMapping);
};
